export default function createCounter() {
  let current = 0;

  return () => {
    current += 1;
    return current;
  };
}



// WEBPACK FOOTER //
// ./src/js/RaptorSession/createCounter.js